import { bool } from "prop-types";
import PlainAnnotationMarker from "./PlainAnnotationMarker.jsx";
import SquareAnnotationMarker from "./SquareAnnotationMarker.jsx";
import { useAnnotationContext } from "./AnnotationContext.jsx";
import { highlightTypes } from "./annotationCommonPropTypes.js";

const propTypes = {
  highlightType: highlightTypes,
  isAnnotated: bool.isRequired,
};

const AnnotationMarker = (props) => {
  const { highlightType, isAnnotated } = props;

  const {
    marker: { markerType },
  } = useAnnotationContext();

  switch (markerType) {
    case "plainFlagWithSelection": // Plain flag, selects text on modal open
      return (
        <PlainAnnotationMarker
          width="26px"
          height="26px"
          highlightType={highlightType}
          isAnnotated={isAnnotated}
        />
      );

    default:
      // Square flag
      return (
        <SquareAnnotationMarker
          width="26px"
          height="26px"
          highlightType={highlightType}
          isAnnotated={isAnnotated}
        />
      );
  }
};

AnnotationMarker.propTypes = propTypes;
export default AnnotationMarker;
